__turbopack_context__.v({
  "button": "eQdRrG_button",
  "container": "eQdRrG_container",
  "fadeSize--sm": "eQdRrG_fadeSize--sm",
  "inner": "eQdRrG_inner",
  "isScrolling": "eQdRrG_isScrolling",
  "left": "eQdRrG_left",
  "leftOverflow": "eQdRrG_leftOverflow",
  "right": "eQdRrG_right",
  "rightOverflow": "eQdRrG_rightOverflow",
});
